import axios from "axios";
import React, { useEffect, useRef } from "react";
import { apiKey } from "../../config/config";
import { toast } from "react-toastify";
import { RxCross1 } from "react-icons/rx";
import MessageCard from "./MessageCard";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { languageHelper } from "../../config/helperFunctions";
// import { useNavigate } from "react-router-dom";

function ShiftModal({
  toggle,
  data,
  error,
  logo,
  general,
  currency,
  isPreview,
}) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));

  const navigate = useNavigate();
  const componentRef = useRef(null);

  const handleCloseShift = () => {
    axios
      .post(
        `${apiKey}/api/rms/admin/shift/close`,
        {
          closing_balance: data?.shift?.closing_balance,
          sale_paid_amount: data?.total?.total_sale_amount,
          total_vat_amount: data?.total?.total_vat_sum,
          total_items: data?.total?.total_items,
          sub_total_amount: data?.total?.sub_total,
          total_discount: data?.total?.total_discount_amount,
          menudetails: JSON.stringify(data?.sold_items),
          total_delivery_charge: data?.total?.total_delivery_charges,
          multiple_payments: JSON.stringify(data?.multi_payment_totals),
          payment_methods_sale: JSON.stringify(data?.payments),
          total_expense: data?.total?.total_expense_amount,
          total_return: JSON.stringify(data?.total_return_amount),
          outlet_id: user?.user?.outlet_id,
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        handlePrint();
        toggle();
      })
      .catch((err) => {
        toast.error(err.response.data?.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Register Details",
    removeAfterPrint: true,
  });

  useEffect(() => {
    // Add the 'body-no-scroll' class to the body when the modal is open
    document.body.classList.add("overflow-y-hidden");

    // Remove the 'overflow-y-hidden' class when the modal is closed
    return () => {
      document.body.classList.remove("overflow-y-hidden");
    };
  }, []);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/verifyShift`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {})
      .catch((err) => {
        if (err) {
          if (!isPreview) {
            navigate("openRegister");
            toggle();
          }
        }
      });
  }, [isPreview, navigate, toggle, user?.token]);

  if (error) {
    return (
      <div
        className="grid place-items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-[100] bg-black bg-opacity-20 fade-in"
        onClick={() => toggle()}
      >
        <div className="relative w-full my-6 mx-auto max-w-3xl">
          <div
            className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white shiftmodel fade-in-down p-2"
            onClick={(e) => e.stopPropagation()}
          >
            <MessageCard error={error || "Error Occured"} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="fixed inset-0 z-[100] grid place-items-center bg-black/40 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      onClick={() => toggle()}
    >
      <div
        className="relative w-full max-w-4xl mx-4 sm:mx-6 lg:mx-8"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Shell */}
        <div className="relative flex max-h-[85vh] flex-col overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-black/5 print:max-h-none print:shadow-none print:ring-0">
          {/* Header */}
          <div className="sticky top-0 z-10 flex items-center gap-3 border-b bg-white/90 px-5 py-4 backdrop-blur print:border-none print:bg-transparent">
            <img
              src={logo?.logo_image_url || ""}
              alt=""
              className="h-10 w-auto shrink-0"
            />
            <div className="min-w-0">
              <p className="text-sm text-amber-600 font-medium">
                ({data?.shift?.opening_balance_date_time}{" "}
                {languageHelper("to Not Closed Yet") || "to Not Closed Yet"})
              </p>
              <h2 className="truncate text-lg font-semibold text-slate-800">
                {languageHelper("Register Details") || "Register Details"}
              </h2>
            </div>

            <button
              className="ml-auto inline-flex h-9 w-9 items-center justify-center rounded-full text-slate-600 hover:bg-slate-100 focus-visible:outline-none focus-visible:ring focus-visible:ring-violet-500 print:hidden"
              onClick={() => toggle()}
              aria-label="Close"
            >
              <span className="text-xl leading-none">
                <RxCross1 />
              </span>
            </button>
          </div>

          {/* Body */}
          <div
            className="relative overflow-y-auto px-5 py-6 print:overflow-visible"
            ref={componentRef}
          >
            {/* Basic Info */}
            <div className="mb-6 grid gap-4 sm:grid-cols-2">
              <div className="rounded-xl border bg-white p-4 shadow-sm">
                <h3 className="mb-3 rounded-md bg-teal-600 px-3 py-2 text-center text-white text-lg font-semibold">
                  Cashier/الكاشير
                </h3>
                <dl className="space-y-2 text-sm">
                  <div className="flex items-start justify-between gap-3">
                    <dt className="text-slate-600">Name/الإسم</dt>
                    <dd className="font-medium text-slate-900">
                      {general?.restaurant_name}
                    </dd>
                  </div>
                  <div className="flex items-start justify-between gap-3">
                    <dt className="text-slate-600">Cashier/الكاشير</dt>
                    <dd className="font-medium text-slate-900">
                      {user?.user?.name}
                    </dd>
                  </div>
                  <div className="flex items-start justify-between gap-3">
                    <dt className="text-slate-600">Contact No/رقم التواصل‎</dt>
                    <dd className="font-medium text-slate-900">
                      {general?.phone}
                    </dd>
                  </div>
                  <div className="flex items-start justify-between gap-3">
                    <dt className="text-slate-600">VAT No/الرقم الضريبي‎</dt>
                    <dd className="font-medium text-slate-900">
                      {general?.tax_reg_no}
                    </dd>
                  </div>
                </dl>
              </div>

              <div className="rounded-xl border bg-white p-4 shadow-sm">
                <h3 className="mb-3 rounded-md bg-fuchsia-700 px-3 py-2 text-center text-white text-lg font-semibold">
                  Opening & Closing
                </h3>
                <dl className="space-y-2 text-sm">
                  <div className="flex items-start justify-between gap-3">
                    <dt className="text-slate-600">
                      Opening Balance/الرصيد الإفتتاحي
                    </dt>
                    <dd className="font-semibold text-slate-900">
                      {currency.value} {data?.shift?.opening_balance}
                    </dd>
                  </div>
                  <div className="flex items-start justify-between gap-3">
                    <dt className="text-slate-600">
                      Closing Balance/الرصيد الختامي
                    </dt>
                    <dd className="font-semibold text-slate-900">
                      {currency.value} {data?.shift?.closing_balance}
                    </dd>
                  </div>
                </dl>
              </div>
            </div>

            {/* Totals */}
            <div className="mb-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
              <div className="rounded-xl border bg-white p-4 shadow-sm">
                <h4 className="mb-3 rounded-md bg-emerald-700 px-3 py-2 text-center text-white text-base font-semibold">
                  {languageHelper("Total Sales Amount/مجموع المبيعات") ||
                    "Total Sales Amount/مجموع المبيعات"}
                </h4>
                <p className="text-center text-xl font-bold">
                  {currency?.value}{" "}
                  {(data?.total?.total_sale_amount || 0).toFixed(2) ||
                    (data?.shift?.sale_paid_amount || 0).toFixed(2)}
                </p>
              </div>

              <div className="rounded-xl border bg-white p-4 shadow-sm">
                <h4 className="mb-3 rounded-md bg-orange-600 px-3 py-2 text-center text-white text-base font-semibold">
                  Sub Total/المجموع الفرعي
                </h4>
                <p className="text-center text-xl font-bold">
                  {currency?.value}{" "}
                  {(data?.total?.sub_total || 0).toFixed(2) ||
                    (data?.shift?.sub_total_amount || 0).toFixed(2)}
                </p>
              </div>

              <div className="rounded-xl border bg-white p-4 shadow-sm">
                <h4 className="mb-3 rounded-md bg-amber-500 px-3 py-2 text-center text-white text-base font-semibold">
                  Total VAT/مجموع ضريبة القيمة المضافة
                </h4>
                <p className="text-center text-xl font-bold">
                  {currency?.value}{" "}
                  {(data?.total?.total_vat_sum || 0).toFixed(2) ||
                    (data?.shift?.total_vat_amount || 0).toFixed(2)}
                </p>
              </div>

              <div className="rounded-xl border bg-white p-4 shadow-sm">
                <h4 className="mb-3 rounded-md bg-sky-500 px-3 py-2 text-center text-white text-base font-semibold">
                  Discount/مجموع الخصم
                </h4>
                <p className="text-center text-xl font-bold">
                  {currency.value}{" "}
                  {(data?.total?.total_discount_amount || 0).toFixed(2) ||
                    (data?.shift?.total_discount || 0).toFixed(2)}
                </p>
              </div>

              <div className="rounded-xl border bg-white p-4 shadow-sm">
                <h4 className="mb-3 rounded-md bg-pink-500 px-3 py-2 text-center text-white text-base font-semibold">
                  Delivery Charges/رسوم التوصيل
                </h4>
                <p className="text-center text-xl font-bold">
                  {currency.value}{" "}
                  {(data?.total?.total_delivery_charges || 0).toFixed(2) ||
                    (data?.shift?.total_delivery_charge || 0).toFixed(2)}
                </p>
              </div>

              <div className="rounded-xl border bg-white p-4 shadow-sm">
                <h4 className="mb-3 rounded-md bg-amber-800 px-3 py-2 text-center text-white text-base font-semibold">
                  Return/عودة كاملة
                </h4>
                <p className="text-center text-xl font-bold">
                  {currency.value}{" "}
                  {(data?.total_return_amount || 0).toFixed(2) ||
                    (data?.shift?.total_return || 0).toFixed(2)}
                </p>
              </div>

              <div className="rounded-xl border bg-white p-4 shadow-sm sm:col-span-2 lg:col-span-1">
                <h4 className="mb-3 rounded-md bg-red-500 px-3 py-2 text-center text-white text-base font-semibold">
                  Sales Items/أصناف المبيعات
                </h4>
                <p className="text-center text-xl font-bold">
                  {data?.total?.total_items ||
                    0 ||
                    data?.shift?.total_items ||
                    0}
                </p>
              </div>

              <div className="rounded-xl border bg-white p-4 shadow-sm sm:col-span-2 lg:col-span-2">
                <h4 className="mb-3 rounded-md bg-fuchsia-700 px-3 py-2 text-center text-white text-base font-semibold">
                  Expense/المصاريف الكلية
                </h4>
                <p className="text-center text-xl font-bold">
                  {currency?.value}{" "}
                  {Number(data?.total_expense_amount || 0)?.toFixed(2)}
                </p>
              </div>
            </div>

            {/* Payments */}
            <div className="mb-6 rounded-xl border bg-white p-4 shadow-sm">
              <h3 className="mb-4 rounded-md bg-pink-600 px-3 py-2 text-center text-white text-lg font-semibold">
                Payment Types/طرق الدفع
              </h3>

              <div className="overflow-hidden rounded-lg border">
                <table className="min-w-full divide-y divide-slate-200 text-sm">
                  <thead className="bg-slate-50">
                    <tr>
                      <th className="px-4 py-2 text-left font-semibold text-slate-700">
                        Type
                      </th>
                      <th className="px-4 py-2 text-right font-semibold text-slate-700">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200">
                    {["Cash", "Mada", "Visa", "Master Card"].map((type) => {
                      const direct = data?.payments?.find(
                        (p) => p.payment?.name === type
                      )?.total_paid_sum;
                      const parsed = (() => {
                        try {
                          return JSON.parse(
                            data?.shift?.payment_methods_sale || "[]"
                          )?.find((p) => p.payment?.name === type)
                            ?.total_paid_sum;
                        } catch {
                          return 0;
                        }
                      })();
                      const amount = direct ?? parsed ?? 0;
                      return (
                        <tr key={type}>
                          <td className="px-4 py-2">{type}</td>
                          <td className="px-4 py-2 text-right font-medium">
                            {currency.value} {amount}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className="mt-4 grid gap-4 md:grid-cols-2">
                <div className="rounded-lg border p-3">
                  <p className="text-sm text-slate-600">
                    Number Of Multiple Payments/عدد عمليات الدفع المتعددة‎
                  </p>
                  <p className="text-xl font-semibold">
                    {(
                      data?.multi_payment_totals ||
                      data?.shift?.multi_payment_totals
                    )?.length || 0}
                  </p>
                </div>
                <div className="rounded-lg border p-3">
                  <p className="mb-2 text-sm text-slate-600">
                    Type Of Multiple Payments/نوع المدفوعات المتعددة
                  </p>
                  <ul className="list-inside list-disc space-y-1">
                    {(
                      data?.multi_payment_totals ||
                      data?.shift?.multi_payment_totals
                    )?.map((pay, i) => (
                      <li key={i} className="text-sm">
                        <span className="font-medium">{pay.payment_name}:</span>{" "}
                        {currency.value} {pay.total_payment_sum}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* Delivery Companies (Section placeholder to keep your structure) */}
            <div className="mb-6 rounded-xl border bg-white p-4 shadow-sm">
              <h3 className="rounded-md bg-rose-600 px-3 py-2 text-center text-white text-lg font-semibold">
                Delivery Companies Payment/دفع شركات التوصيل
              </h3>
              {/* Add rows here if/when you show per-company breakdown */}
            </div>

            {/* Sold Items */}
            <div className="rounded-xl border bg-white p-4 shadow-sm">
              <h3 className="mb-4 rounded-md bg-sky-800 px-3 py-2 text-center text-white text-lg font-semibold">
                Quantity of items/عدد الأصناف
              </h3>

              <div className="overflow-hidden rounded-lg border">
                <table className="min-w-full divide-y divide-slate-200 text-sm">
                  <thead className="bg-slate-50">
                    <tr>
                      <th className="px-4 py-2 text-left font-semibold text-slate-700">
                        Item
                      </th>
                      <th className="px-4 py-2 text-right font-semibold text-slate-700">
                        Qty
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200">
                    {(
                      data?.sold_items ||
                      (() => {
                        try {
                          return JSON.parse(data?.shift?.menudetails || "[]");
                        } catch {
                          return [];
                        }
                      })()
                    )?.map((item, index) => (
                      <tr key={index}>
                        <td className="px-4 py-2">
                          {item.item_name} / {item.item_name_ar}
                        </td>
                        <td className="px-4 py-2 text-right font-medium">
                          {item.total_quantity}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="sticky bottom-0 flex flex-wrap items-center justify-center gap-3 border-t bg-white/90 px-5 py-4 backdrop-blur print:hidden">
            <button
              className="inline-flex items-center rounded-lg bg-slate-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-slate-800 focus-visible:outline-none focus-visible:ring focus-visible:ring-slate-500"
              type="button"
              onClick={() => toggle()}
            >
              Back/رجوع
            </button>

            <button
              className="inline-flex items-center rounded-lg bg-d-cat-btn px-4 py-2 text-sm font-medium text-white shadow-sm hover:brightness-110 focus-visible:outline-none focus-visible:ring focus-visible:ring-violet-500"
              type="button"
              onClick={() => handlePrint()}
            >
              Print/طباعة
            </button>

            {!isPreview && (
              <button
                className="inline-flex items-center rounded-lg bg-d-cat-btn px-4 py-2 text-sm font-medium text-white shadow-sm hover:brightness-110 focus-visible:outline-none focus-visible:ring focus-visible:ring-violet-500"
                type="button"
                onClick={() => handleCloseShift()}
              >
                Print &amp; Close/طباعة وإغلاق
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShiftModal;
